import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { TenantThemeProvider } from './tenant/TenantThemeProvider';
import { ToastProvider } from './ui/ToastProvider';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <TenantThemeProvider>
    <ToastProvider>
      <App />
    </ToastProvider>
  </TenantThemeProvider>
);

if ('serviceWorker' in navigator && process.env.NODE_ENV === 'production') {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register(`${process.env.PUBLIC_URL}/sw.js`).catch(() => {});
  });
}

reportWebVitals();
